import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { StudentContractIssueData, StudentContractResponse } from '@/types/api'

export const STUDENT_CONTRACT_KEY = ['contract'] as const

/** R12-02: status do contrato do aluno. So consulta quando `enabled` (aluno com plano pago). */
export function useStudentContract(enabled: boolean) {
  return useQuery({
    queryKey: STUDENT_CONTRACT_KEY,
    queryFn: () => api.contract.get(),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}

/** "Ja assinei" do onboarding: a API consulta o Autentique e devolve o status atualizado. */
export function useRefreshStudentContract() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api.contract.refresh(),
    onSuccess: (response: StudentContractResponse) => queryClient.setQueryData(STUDENT_CONTRACT_KEY, response),
  })
}

/** Emite (ou devolve o existente) e grava a resposta no cache, sem refetch. */
export function useIssueStudentContract() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: StudentContractIssueData) => api.contract.issue(data),
    onSuccess: (response: StudentContractResponse) => queryClient.setQueryData(STUDENT_CONTRACT_KEY, response),
  })
}
